import { render } from "./PhotoClassifyLineView.vue?vue&type=template&id=08e0d887&scoped=true"
import script from "./PhotoClassifyLineView.vue?vue&type=script&lang=js"
export * from "./PhotoClassifyLineView.vue?vue&type=script&lang=js"

import "./PhotoClassifyLineView.vue?vue&type=style&index=0&id=08e0d887&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e0d887"]])

export default __exports__